import "./Loading.css";
import { CircularProgress, Container } from "@material-ui/core";

function Loading({ paddingTop = "25%" }: { paddingTop?: string }) {
  return (
    <Container className="LoadingScreen" style={{ backgroundColor: "inherit" }}>
      <div className="general" style={{ paddingTop }}>
        <CircularProgress style={{ paddingBottom: "10px" }} />
        <div>Loading...</div>
      </div>
    </Container>
  );
}

export default Loading;
